import { useObjectTypeSelect } from '../../../hooks/useObjectTypeSelect';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import I18n from 'I18n';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import UISelect from 'UIComponents/input/UISelect';
import { useEditorActions } from '../../../hooks/useEditorActions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ObjectSelect = () => {
  const {
    defaultValue,
    filteringObjectDropdownLabel,
    hasOnlyOneOption,
    itemComponent,
    isCurrentObject,
    options,
    value,
    onChange: onObjectTypeSelectChange
  } = useObjectTypeSelect(true);
  const {
    setCategory
  } = useEditorActions();
  if (hasOnlyOneOption) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Flex, {
    paddingInlineStart: "400",
    paddingInlineEnd: "400",
    paddingBlockStart: "400",
    alignItems: "baseline",
    children: [/*#__PURE__*/_jsx(View, {
      paddingInlineEnd: "200",
      as: "div",
      children: filteringObjectDropdownLabel || /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "customerDataFiltersUI.objectTypeSelect.filteringOn.singlePanel",
        options: {
          type: isCurrentObject ? I18n.text('customerDataFiltersUI.objectTypeSelect.currentObject') : I18n.text('customerDataFiltersUI.objectTypeSelect.associatedObject')
        }
      })
    }), /*#__PURE__*/_jsx(UISelect, {
      defaultValue: defaultValue,
      itemComponent: itemComponent,
      onChange: event => {
        onObjectTypeSelectChange(event);
        setCategory(undefined);
      },
      options: options,
      readOnly: hasOnlyOneOption,
      value: value,
      buttonSize: "xs",
      buttonUse: "tertiary-light",
      menuWidth: "auto"
    })]
  });
};
export default ObjectSelect;